export enum AvatarSize {
  _4XS = '4xs',
  _3XS = '3xs',
  _2XS = '2xs',
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  _2XL = '2xl',
  _3XL = '3xl',
  _4XL = '4xl',
}
